let runtimeId = 0;

export function nextRuntimeId(): string {
  return `${++runtimeId}`;
}
